import { TEMPLATE_ID } from '../constants/templates';

export const getConfirmEmail = recipient => {
    return {
        // subject: `Confirm email address`,
        subject: `Sidekick Network`,
        sendTo: [recipient],
        email: recipient.email,
        buttonTitle: 'Confirm email address',
        templateId: TEMPLATE_ID.CONFIRM_EMAIL,
    };
};

export const getEmailsForHiredAfterDeletePost = (
    senderEmail,
    projectTitle,
    recipients,
    projectOwnerFirstName,
    projectOwnerLastName,
    link,
    category
) => {
    return {
        senderEmail,
        projectOwnerFirstName,
        projectOwnerLastName,
        projectTitle,
        category,
        subject: `Sidekick Network`,
        // subject: `Project you've been hired for was deleted.`,
        sendTo: recipients,
        templateId: TEMPLATE_ID.DELETE_POST_FOR_HIRED,
        link: link,
    };
};

export const getEmailsForInvitedAfterDeletePost = (
    senderEmail,
    projectTitle,
    recipients,
    projectOwnerFirstName,
    projectOwnerLastName,
    link,
    category
) => {
    return {
        senderEmail,
        projectOwnerFirstName,
        projectOwnerLastName,
        projectTitle,
        category,
        subject: `Sidekick Network`,
        // subject: `Project you've been invited for was deleted.`,
        sendTo: recipients,
        templateId: TEMPLATE_ID.DELETE_POST_FOR_INVITED, // need to create new template
        link: link,
    };
};

export const getNewReview = (recipient, link) => {
    return {
        firstName: recipient.firstName,
        subject: `Sidekick Network`,
        // subject: `You’re getting advice.`,
        sendTo: [recipient],
        link: link,
        buttonTitle: 'Go to project',
        templateId: TEMPLATE_ID.NEW_REVIEW,
    };
};

export const getFirstAnswerForInvite = (senderEmail, recipient, link, projectTitle) => {
    return {
        senderEmail,
        firstName: recipient.firstName,
        projectTitle: projectTitle,
        subject: `Sidekick Network`,
        // subject: `Your post is getting responces`,
        sendTo: [recipient],
        link: link,
        buttonTitle: 'Go to project',
        templateId: TEMPLATE_ID.FIRST_ANSWER_TO_INVITE,
    };
};

export const getHireToAnswer = (
    senderEmail,
    projectTitle,
    recipients,
    projectOwnerFirstName,
    projectOwnerLastName,
    link,
    category
) => {
    return {
        senderEmail,
        projectOwnerFirstName,
        projectOwnerLastName,
        projectTitle,
        category,
        subject: `Sidekick Network`,
        // subject: `Congratulations! You've been hired`,
        sendTo: recipients,
        buttonTitle: 'Go to post',
        templateId: TEMPLATE_ID.HIRE_FREELANCER,
        link: link,
    };
};

export const getNotHireToAnswer = (
    senderEmail,
    recipients,
    projectOwnerFirstName,
    projectOwnerLastName,
    link,
    category
) => {
    return {
        senderEmail,
        projectOwnerFirstName: projectOwnerFirstName,
        projectOwnerLastName: projectOwnerLastName,
        category: category,
        subject: `Sidekick Network`,
        // subject: `Sorry, you've not been accepted this time`,
        sendTo: recipients,
        buttonTitle: 'Go to post',
        templateId: TEMPLATE_ID.NOT_HIRE_FREELANCER,
        link: link,
    };
};

export const getInvoice = (senderEmail, projectTitle, recipients, link, category) => {
    return {
        senderEmail,
        projectTitle,
        // firstName: recipient.firstName,
        subject: `Sidekick Network`,
        // subject: `Get paid!`,
        sendTo: recipients,
        link: link,
        category: category,
        templateId: TEMPLATE_ID.REQUEST_INVOICE,
    };
};

export const getCompleteProject = (senderEmail, recipients, link) => {
    return {
        senderEmail,
        subject: `Sidekick Network`,
        // subject: `It's completed :)`,
        sendTo: recipients,
        link: link,
        templateId: TEMPLATE_ID.COMPLETE_PROJECT,
    };
};

export const getDeclinePost = (senderEmail, recipient, link) => {
    return {
        senderEmail,
        firstName: recipient.firstName,
        subject: `Sidekick Network`,
        // subject: `Sorry, your post has been rejected`,
        sendTo: [recipient],
        buttonTitle: 'Go to post',
        templateId: TEMPLATE_ID.DECLINE_POST,
        link: link,
    };
};

export const getAcceptPost = (senderEmail, recipient, link) => {
    return {
        senderEmail,
        subject: `Sidekick Network`,
        // subject: `Your post has been approved`,
        sendTo: [recipient],
        buttonTitle: 'Go to project',
        templateId: TEMPLATE_ID.ACCEPT_POST,
        link: link,
    };
};

export const getReceiveMoneyEmail = (email, firstName, senderFirstName) => {
    return {
        firstName: firstName,
        subject: `Sidekick Network`,
        // subject: `Someone’s paid you!`,
        sendTo: [email],
        buttonTitle: 'Accept Payment',
        templateId: TEMPLATE_ID.RECEIVE_MONEY_EMAIL,
        senderFirstName: senderFirstName,
    };
};

export const getReceiveMoneyWithoutStripeAccountEmail = (
    email,
    firstName,
    senderFirstName,
    link
) => {
    return {
        firstName: firstName,
        subject: `Sidekick Network`,
        // subject: `Someone’s paid you!`,
        sendTo: [email],
        templateId: TEMPLATE_ID.RECEIVE_MONEY_WITHOUT_STRIPE_ACCOUNT_EMAIL,
        senderFirstName: senderFirstName,
        link: link,
        buttonTitle: 'Accept Payment',
    };
};

export const getInviteToAnswer = (
    senderEmail,
    projectTitle,
    projectDescription,
    recipients,
    firstName,
    lastName,
    uid,
    link,
    postUid,
    postCategory,
    notionLink,
    budget
) => {
    return {
        projectTitle,
        projectDescription,
        firstName,
        lastName,
        uid,
        senderEmail,
        postUid,
        subject: `NEW Sidekick Network opportunity`,
        // subject: `You have been invited to a ${projectTitle} project`,
        sendTo: recipients,
        buttonTitle: 'Go to project',
        templateId: TEMPLATE_ID.INVITE_TO_ANSWER,
        category: postCategory,
        link,
        notionLink,
        budget,
    };
};
